export default __webpack_public_path__ + "static/media/mailing.3c8543e3.jpeg";